import { Alert, Button, Form, Input, InputNumber, Select, Skeleton, Space, message } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { countryCodes } from '../../Utility/CountryCodes';
import SelectDropdown from '../../Utility/SelectDropdown';

function AgencyForm({ agency_name, agency_id, finalPayload, setFinalPayload, setCurrent, editMode, applicationData, loading }) {

    const userFormRef = useRef();
    const [mobileCountryCode, setMobileCountryCode] = useState('+91');

    const handleAgencyData = (values) => {

        const payLoad = { ...values, 'supervisor_mobile_country_code': mobileCountryCode };
        setFinalPayload({ ...finalPayload, ...payLoad })
        setCurrent(1);
    }

    const countrySelect = (
        <Select
            showSearch
            popupMatchSelectWidth={false}
            value={mobileCountryCode}
            onChange={(value) => setMobileCountryCode(value)}
            optionFilterProp="children"
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input)}
            filterSort={(optionA, optionB) =>
                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={countryCodes}
        >
            {/* {
                countryCodes.map(item => (
                    <Option key={item.value} value={item.value}>{item.label}</Option>
                ))
            } */}
        </Select>
    );

    useEffect(() => {
        console.log(applicationData)
        if (applicationData.length > 0) {
            setMobileCountryCode(applicationData[0].supervisor_mobile_country_code)
        }
    }, [editMode, applicationData])

    return (

        <Skeleton loading={loading} active>

            <div className="text-muted h6 my-3 text-center">
                Application Type:
                <Alert
                    className='d-inline-block ms-2'
                    message={applicationData.length > 0 ? "Re-Application" : "New"} type={applicationData.length > 0 ? 'warning' : 'info'}
                />
            </div>
            <Form
                name="agency-form"
                ref={userFormRef}
                layout="vertical"
                onFinish={handleAgencyData}
                autoComplete='off'
                initialValues={
                    editMode
                        ? {
                            contract_type_id: applicationData[0]?.contract_type_id,
                            contractor_po_number: applicationData[0]?.contractor_po_number,
                            unit_id: applicationData[0]?.unit_id,
                            department_id: applicationData[0]?.department_id,
                            function_id: applicationData[0]?.function_id,
                            section_id: applicationData[0]?.section_id,

                            supervisor_name: applicationData[0]?.supervisor_name,
                            supervisor_mobile: applicationData[0]?.supervisor_mobile
                        }
                        : ''
                }
            >
                <div className='row'>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Agency Name"
                            name="agency_name"
                            initialValue={agency_name}

                            rules={[
                                {
                                    required: true,
                                    message: 'Agency Name is required',
                                },

                            ]}
                        >
                            <Input disabled />
                        </Form.Item>
                    </div>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Unit Name"
                            name="unit_id"

                            rules={[
                                {
                                    required: true,
                                    message: 'Unit Name is required',
                                },

                            ]}
                        >
                            <SelectDropdown
                                //onSelect={handleInterviewerSelect}
                                size="large"
                                path='/api/unit'
                                placeholder="Select Unit"
                                fieldKey='unit_full_name' />

                        </Form.Item>
                    </div>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Type of contract"
                            name="contract_type_id"
                            //initialValue={candidateData.length > 0 ? candidateData[0].job_type : ''}
                            rules={[
                                {
                                    required: true,
                                    message: 'Type of contract is required',
                                },

                            ]}
                        >
                            <SelectDropdown
                                //onSelect={handleInterviewerSelect}
                                size="large"
                                path='/api/contracttype'
                                placeholder="Type of contract"
                                fieldKey='name' />

                        </Form.Item>
                    </div>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Contractor PO No."
                            name="contractor_po_number"

                            rules={[
                                {
                                    required: true,
                                    message: 'Contractor PO No. is required',
                                },

                            ]}
                        >
                            <Input placeholder='Enter Contractor PO Number' />
                        </Form.Item>
                    </div>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Department Name"
                            name="department_id"

                            rules={[
                                {
                                    required: true,
                                    message: 'Department Name is required',
                                },

                            ]}
                        >
                            <SelectDropdown
                                //onSelect={handleInterviewerSelect}
                                size="large"
                                path='/api/department'
                                placeholder="Select Department"
                                fieldKey='name' />
                        </Form.Item>

                    </div>
                    <div className='col-sm-4'>

                        <Form.Item
                            label="Function Name"
                            name="function_id"

                            rules={[
                                {
                                    required: true,
                                    message: 'Function Name is required',
                                },

                            ]}
                        >
                            <SelectDropdown
                                //onSelect={handleInterviewerSelect}
                                size="large"
                                path='/api/function'
                                placeholder="Select Function Name"
                                fieldKey='name' />
                        </Form.Item>
                    </div>
                    {/* <div className='col-sm-4'>
                        <Form.Item
                            label="Work Area Name"
                            name="work_area"


                        >
                            <Input placeholder='Enter Work area name' />
                        </Form.Item>

                    </div> */}
                    <div className='col-sm-4'>

                        <Form.Item
                            label="Work Area / Section Name"
                            name="section_id"

                            rules={[
                                {
                                    required: true,
                                    message: 'Section Name is required',
                                },

                            ]}
                        >
                            <SelectDropdown
                                //onSelect={handleInterviewerSelect}
                                size="large"
                                path='/api/section'
                                placeholder="Select Section Name"
                                fieldKey='name' />
                        </Form.Item>
                    </div>



                    <div className='col-sm-4'>
                        <Form.Item
                            label="Agency Supervisor"
                            name="supervisor_name"

                            rules={[
                                {
                                    required: true,
                                    message: 'Agency Supervisor is required',
                                },

                            ]}
                        >
                            <Input placeholder='Enter Agency Supervisor Name' />
                        </Form.Item>
                    </div>
                    <div className='col-sm-4'>
                        <Form.Item
                            label="Agency Supervisor Mobile"
                            name="supervisor_mobile"

                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter 10 digit mobile number',
                                    /* pattern: /^[0-9]{10}$/ */
                                },

                            ]}
                        >

                            <InputNumber addonBefore={countrySelect} controls={false} placeholder='Enter Agency Supervisor 
                            Mobile' />

                        </Form.Item>

                    </div>
                    <div className='col-sm-12 d-flex justify-content-end'>
                        <Button htmlType='submit' type="primary" /* onClick={() => setCurrent(1)} */ className='px-5' size="large">Next</Button>
                    </div>
                </div>
            </Form>
        </Skeleton>
    )
}

export default AgencyForm